export function getDeviceID(): string {
  const deviceID = localStorage.getItem("deviceID")

  if (!deviceID) {
    // generate new device ID
    const newDeviceID = crypto.randomUUID()
    localStorage.setItem("deviceID", newDeviceID)
    return newDeviceID
  }

  return deviceID
}
